/**
 * @name THEME_TYPOGRAPHY_VARIANT_NAMES
 * @description typography types
 */
export const THEME_TYPOGRAPHY_VARIANT_NAMES = {
  DISPLAY1: 'display1',
  DISPLAY2: 'display2',
  DISPLAY3: 'display3',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  BODY1: 'body1',
  BODY2: 'body2',
  BODY3: 'body3',
  BODY4: 'body4',
  CAPTION1: 'caption1',
  CAPTION2: 'caption2',
  CAPTION3: 'caption3',
};

/**
 * @name THEME_TYPOGRAPHY_ATTRIBUTE_NAMES
 * @description typography attributes
 */
export const THEME_TYPOGRAPHY_ATTRIBUTE_NAMES = {
  FONT_FAMILY: 'font-family',
  FONT_WEIGHT: 'font-weight',
  FONT_SIZE: 'font-size',
  LINE_HEIGHT: 'line-height',
  TEXT_DECORATION: 'text-decoration',
};

/**
 * @name THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES
 * @description font weight types
 */
export const THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES = {
  BOLD: 'bold',
  REGULAR: 'regular',
  LIGHT: 'light',
};

/**
 * @name THEME_TYPOGRAPHY_ENDPOINT
 * @description typography endpoint
 */
export const THEME_TYPOGRAPHY_ENDPOINT =
  '//prod.cms.col.movistar.es/static/fonts/gp/';
